import { render, staticRenderFns } from "./storageLocation.vue?vue&type=template&id=12433170&scoped=true&"
import script from "./storageLocation.vue?vue&type=script&lang=js&"
export * from "./storageLocation.vue?vue&type=script&lang=js&"
import style0 from "./storageLocation.vue?vue&type=style&index=0&id=12433170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12433170",
  null
  
)

export default component.exports